// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Michelangelo() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/Michelangelo/Michelangelo_1.JPG',
        },
        {
            id: 2,
            imgSrc: '/images/Michelangelo/Michelangelo_2.JPG',
        },
        {
            id: 3,
            imgSrc: '/images/Michelangelo/Michelangelo_3.JPG',
        },
        {
            id: 4,
            imgSrc: '/images/Michelangelo/Michelangelo_4.JPG',
        },
        {
            id: 5,
            imgSrc: '/images/Michelangelo/Michelangelo_5.JPG',
        },
        {
            id: 6,
            imgSrc: '/images/Michelangelo/Michelangelo_6.JPG',
        },
        {
            id: 7,
            imgSrc: '/images/Michelangelo/Michelangelo_7.JPG',
        },
        {
            id: 8,
            imgSrc: '/images/Michelangelo/Michelangelo_8.JPG',
        },
        {
            id: 9,
            imgSrc: '/images/Michelangelo/Michelangelo_9.JPG',
        },
        {
            id: 10,
            imgSrc: '/images/Michelangelo/Michelangelo_10.JPG',
        },
        {
            id: 11,
            imgSrc: '/images/Michelangelo/Michelangelo_11.JPG',
        },
        {
            id: 12,
            imgSrc: '/images/Michelangelo/Michelangelo_12.JPG',
        },
        {
            id: 13,
            imgSrc: '/images/Michelangelo/Michelangelo_13.JPG',
        },
        {
            id: 14,
            imgSrc: '/images/Michelangelo/Michelangelo_14.JPG',
        },
        {
            id: 15,
            imgSrc: '/images/Michelangelo/Michelangelo_15.JPG',
        },
        {
            id: 16,
            imgSrc: '/images/Michelangelo/Michelangelo_16.JPG',
        },
        {
            id: 17,
            imgSrc: '/images/Michelangelo/Michelangelo_17.JPG',
        },
        {
            id: 18,
            imgSrc: '/images/Michelangelo/Michelangelo_18.JPG',
        },
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Michelangelo Vizzini" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Michelangelo Vizzini" style={{width: '100%'}} loading="lazy"  />
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Michelangelo;
